export const API_ENDPOINT = process.env.NODE_ENV === "production"
    ? "https://api.vivamoselcampo.co/v1"
    : "";
export const STATICS_URL = process.env.NODE_ENV === "production"
    ? "https://static.vivamoselcampo.co/"
    : "http://localhost:9015/v1/";
export const GOOGLE_ANALYTICS_KEY = process.env.NODE_ENV === "production"
    ? "UA-100832282-1"
    : "";
export const GOOGLE_ADWORDS_KEY = process.env.NODE_ENV === "production"
    ? "AW-869260225"
    : "";
export const FB_PIXEL_ID = process.env.NODE_ENV === "production"
    ? "1138053903013830"
    : "";

export const GOOGLE_MAPS_KEY = "AIzaSyAS01GFLXtfNhnr9s-bazmf4wUUWCC4-wY";

export const IVA = 0;



// WEBPACK FOOTER //
// ./src/config/constants.js